import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'priceFormat' })
export class PriceFormatPipe implements PipeTransform {
  transform(value: number): string {

    const hasDecimal = value % 1 !== 0;
    const rounded = hasDecimal ? value.toFixed(2) : Math.round(value).toString();
    const [intPart, decPart] = rounded.split('.');

    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return hasDecimal
      ? `${formattedInt},${decPart}`
      : `${formattedInt}`;
  }
}
